export default "__VITE_ASSET__CH$NaoAN__"